import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AttachmentsPanel from './AttachmentsPanel';
import { addAttachment, updateAttachment, deleteAttachmentWithRefresh } from '../../actions/apiAttachments';
import { storeReconFile, timestampFileId } from './reconFilesUpload';

const AppraisalAttachments = ({ appraisalId, vehicleId, title = 'Files' }) => {
  const dispatch = useDispatch();
  const active_vehicle = useSelector(state => state.settings_refresh?.active_vehicle || {});
  const dealership = useSelector(state => state.settings_dealerships?.installation?.subdomain || state.settings_dealerships?.current_dealership || '');
  const currentUser = useSelector(state => state.current_user || {});

  const attachments = useMemo(
    () => (active_vehicle?.attachments || []).filter(a => String(a.appraisal_id) === String(appraisalId)),
    [active_vehicle, appraisalId],
  );

  const siteid = `${dealership}_${vehicleId}`;

  const onUpload = async (file) => {
    const fileid = timestampFileId(file);
    const stored = await storeReconFile(file, fileid, siteid, { kind: 'appraisal', vehicleId });
    await dispatch(addAttachment({
      vehicle_id: vehicleId,
      appraisal_id: appraisalId,
      filename: stored.fileid,
      location: stored.url,
      fileid: stored.fileid,
      siteid: stored.siteid,
      caption: '',
      user_name: currentUser.user_name,
      uid: currentUser.user,
    }, 'addAttachmentError'));
  };

  return (
    <AttachmentsPanel
      title={title}
      attachments={attachments}
      onUpload={onUpload}
      onSaveCaption={(a, caption) => dispatch(updateAttachment(a.id, { vehicle_id: vehicleId, caption }))}
      onDelete={a => dispatch(deleteAttachmentWithRefresh(vehicleId, a.id))}
    />
  );
};

export default AppraisalAttachments;
